import styled from '@emotion/styled';

import { COLORS3, FONT, MEDIA_QUERY, SPACING } from '../../styles/emotion';

export const ReviewItemWrapper = styled.div`
  margin-bottom: ${SPACING.MD};

  ${MEDIA_QUERY.EXCLUDE_DESKTOP} {
    align-self: flex-start;
    width: 100%;
  }

  ${MEDIA_QUERY.DESKTOP} {
    max-width: 294px;
  }
`;

export const StarsWrapper = styled.div`
  svg {
    color: #f4c042;
  }
`;

export const Name = styled.p`
  margin: ${SPACING.MD} 0 ${SPACING.S16} 0;
  font-size: ${FONT.FONT_SIZE_SMALL};

  ${MEDIA_QUERY.MOBILE} {
    margin: ${SPACING.S16} 0 ${SPACING.SM};
  }
`;

export const Title = styled.h4`
  ${FONT.textSizeCompact(FONT.SIZE.SMALL)}
  margin: 0 0 6px 0;
  font-weight: ${FONT.FONT_WEIGHT_SEMI_BOLD};
  color: var(--support-accordion-text-color, ${COLORS3.WHITE_100});

  ${MEDIA_QUERY.EXCLUDE_MOBILE} {
    ${FONT.textSizeCompact(FONT.SIZE.REGULAR)}
    margin: 0 0 ${SPACING.XS} 0;
  }
`;

export const SRText = styled.span`
  border: 0 !important;
  clip: rect(1px, 1px, 1px, 1px) !important;
  -webkit-clip-path: inset(50%) !important;
  clip-path: inset(50%) !important;
  height: 1px !important;
  margin: -1px !important;
  overflow: hidden !important;
  padding: 0 !important;
  position: absolute !important;
  width: 1px !important;
  white-space: nowrap !important;
`;
